<template>
	<div class="wrapper">
		<div class="section section-blogs-2 topsearch">
			<div class="container main">
				<div class="md-layout">
					<div
							class="md-layout-item md-size-100 md-small-size-100 mx-auto"
					>
						<router-link
								id="buttonback"
								:to="{ name: 'windowParamItemData', params: { id: this.$route.params.id} }"
						>
							<md-icon>keyboard_arrow_left</md-icon>Назад к свойству
						</router-link>
					</div>
					<div
							class="md-layout-item md-size-100 md-small-size-100 mx-auto"
					>
						<div class="name">
							<h3 class="title">
								Редактирование допустимого параметра {{ form['paramName'] }}
							</h3>
							<div
									v-if="param"
									class="md-layout-item md-size-100 md-xsmall-size-100 fieldsep"
							>
								<div
										class="md-layout-item md-size-40 md-xsmall-size-100 text-center fieldsep"
								>
									<md-field
											:class="getValidationClass('typeValVal')"
									>
										<label>{{
											mapElementName['typeValVal']
											}}</label>
										<md-input
												v-if="action === 'delete'"
												readonly
												v-model.number="form['typeValVal']"
												type="text"
										></md-input>
										<md-input
												v-else
												v-model="form['typeValVal']"
												type="text"
										></md-input>
										<span
												class="md-error"
												v-if="!$v.form.typeValVal.required"
										>Обязательно для заполнения</span>
									</md-field>
								</div>
								<div
										class="md-layout-item md-size-40 md-xsmall-size-100 text-center fieldsep"
								>
									<md-field
											:class="getValidationClass('typeValDesc')"
									>
										<label>{{
											mapElementName['typeValDesc']
											}}</label>
										<md-input
												v-if="action === 'delete'"
												readonly
												v-model.number="form['typeValDesc']"
												type="text"
										></md-input>
										<md-input
												v-else
												v-model="form['typeValDesc']"
												type="text"
										></md-input>
										<span
												class="md-error"
												v-if="!$v.form.typeValDesc.required"
										>Обязательно для заполнения</span>
									</md-field>
								</div>
							</div>
							<br />
							<div
									class="md-layout-item md-gutter md-size-100 md-xsmall-size-100 fieldsep"
							>
								<template v-if="param">
									<md-button
											v-if="action !== 'delete'"
											@click="validateData(saveItem)"
											class="md-button md-success md-theme-default"
									>Сохранить</md-button
									>

									<md-button
											v-if="action === 'delete'"
											@click="validateData(deleteItem)"
											class="md-button md-primary md-theme-default"
									>Удалить</md-button
									>
								</template>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
	import { validationMixin } from 'vuelidate'
	import { checkAuthentication, reAuthenticate } from '@/utils/auth-api'
	import { required } from 'vuelidate/lib/validators'
	import { getItem, saveItem, deleteItem } from '@/utils/dict-api'

	export default {
		mixins: [validationMixin],
		bodyClass: 'dictionary-data',
		props: ['page', 'action'],
		data() {
			return {
				param: false,
				mapElementName: {
					"typeValVal": "Значение параметра",
					"typeValDesc": "Описание значения параметра"
				},
				form: {
					action: 'save',
					typeValVal: '',
					typeValDesc: '',
				},
			}
		},
		validations: {
			form: {
				typeValVal: {required},
				typeValDesc: {required},
			},
		},
		watch: {},
		methods: {
			getValidationClass(fieldName) {
				const field = this.$v.form[fieldName];
				if (field) {
					return {
						'md-invalid': field.$invalid && field.$dirty,
					}
				}
			},
			validateData(sendFn) {
				this.$v.form.$touch()
				if (!this.$v.form.$invalid) {
					sendFn()
				}
			},
			setData: function(data) {
				this.form = data
			},
			getElementData: function() {
				if (this.$route.params.paramId === 'new') {
					this.addItem()
					return
				}
				checkAuthentication(this.$router, this.$route).then(response => {
					getItem('paramtypevalue', this.$route.params.paramId)
							.then(result => {
								this.param = result
								this.setData(this.param)
							})
							.catch(error => {
								reAuthenticate(this.$router, this.$route, error)
							})
				})
			},
			addItem: function() {
				const item = {
					id: 'new',
					typeValVal: '',
					typeValDesc: '',
					typeId: this.$route.params.id,
					paramName: 'test',
					paramDesc: 'test'
				}
				this.setData(item)
				this.param = item
			},
			saveItem: function() {
				if (this.form.id === 'new') {
					this.form.id = null
				}
				checkAuthentication(this.$router, this.$route).then(response => {
					saveItem('paramtypevalue', JSON.stringify(this.form))
							.then(result => {
								this.$router.push({ name: 'windowParamItemData', params: { id: this.$route.params.id} })
							})
							.catch(error => {
								reAuthenticate(this.$router, this.$route, error)
							})
				})
			},
			deleteItem: function() {
				checkAuthentication(this.$router, this.$route).then(response => {
					deleteItem(
							'paramtypevalue',
							JSON.stringify({ id: this.$route.params.paramId })
					)
							.then(result => {
								this.$router.push({ name: 'windowParamItemData', params: { id: this.$route.params.id} })
							})
							.catch(error => {
								reAuthenticate(this.$router, this.$route, error)
							})
				})
			},
		},
		created() {
			if (this.$route.params.action == 'delete') {
				this.deleteItem()
			} else {
				this.getElementData()
			}
		},
	}
</script>

<style lang="scss" scoped type="text/scss">
	.dictionary-data .md-field {
		padding-top: 16px;
		margin: 4px 0 24px;
	}

	.offset-left-16 {
		margin-left: 16px;
	}
</style>
